var global = require("./shim/global.js");
var vP18556 = require("./27.js");
var vP185562 = require("./308.js");
var vP185563 = require("./281.js");
var vP185564 = require("./309.js");
function a(p18558, p18559 = +Infinity, p18560 = +Infinity) {
  try {
    return f2235("", p18558, p18559, p18560);
  } catch (e196) {
    return {
      ERROR: "**non-serializable** (" + e196 + ")"
    };
  }
}
exports.a = a;
function f2234(p18561, p18562 = 3, p18563 = 102400) {
  const vF2233 = a(p18561, p18562);
  if (f2239(vF2233) > p18563) {
    return f2234(p18561, p18562 - 1, p18563);
  } else {
    return vF2233;
  }
}
function f2235(p18564, p18565, p18566 = +Infinity, p18567 = +Infinity, p18568 = Object(vP185562.a)()) {
  const [v14226, v14227] = p18568;
  if (p18565 === null || ["number", "boolean", "string"].includes(typeof p18565) && !Object(vP18556.e)(p18565)) {
    return p18565;
  }
  const vI24 = f2236(p18564, p18565);
  if (!vI24.startsWith("[object ")) {
    return vI24;
  }
  if (p18565.__sentry_skip_normalization__) {
    return p18565;
  }
  let vP18566 = p18566;
  if (typeof p18565.__sentry_override_normalization_depth__ == "number") {
    vP18566 = p18565.__sentry_override_normalization_depth__;
  }
  if (vP18566 === 0) {
    return vI24.replace("object ", "");
  }
  if (v14226(p18565)) {
    return "[Circular ~]";
  }
  const vP18565 = p18565;
  if (vP18565 && typeof vP18565.toJSON == "function") {
    try {
      const v14228 = vP18565.toJSON();
      return f2235("", v14228, vP18566 - 1, p18567, p18568);
    } catch (e197) {}
  }
  const v14229 = Array.isArray(p18565) ? [] : {};
  let vLN02606 = 0;
  const vObject6 = Object(vP185563.b)(p18565);
  for (const v14230 in vObject6) {
    if (!Object.prototype.hasOwnProperty.call(vObject6, v14230)) {
      continue;
    }
    if (vLN02606 >= p18567) {
      v14229[v14230] = "[MaxProperties ~]";
      break;
    }
    const v14231 = vObject6[v14230];
    v14229[v14230] = f2235(v14230, v14231, vP18566 - 1, p18567, p18568);
    vLN02606++;
  }
  v14227(p18565);
  return v14229;
}
function f2236(p18569, p18570) {
  try {
    if (p18569 === "domain" && p18570 && typeof p18570 == "object" && p18570._events) {
      return "[Domain]";
    } else if (p18569 === "domainEmitter") {
      return "[DomainEmitter]";
    } else if (typeof global != "undefined" && p18570 === global) {
      return "[Global]";
    } else if (typeof window != "undefined" && p18570 === window) {
      return "[Window]";
    } else if (typeof document != "undefined" && p18570 === document) {
      return "[Document]";
    } else if (Object(vP18556.j)(p18570)) {
      return "[SyntheticEvent]";
    } else if (typeof p18570 == "number" && p18570 !== p18570) {
      return "[NaN]";
    } else if (p18570 === undefined) {
      return "[undefined]";
    } else if (typeof p18570 == "function") {
      return "[Function: " + Object(vP185564.a)(p18570) + "]";
    } else if (typeof p18570 == "symbol") {
      return "[" + (p18570 + "") + "]";
    } else if (typeof p18570 == "bigint") {
      return "[BigInt: " + (p18570 + "") + "]";
    } else {
      return "[object " + f2237(p18570) + "]";
    }
  } catch (e198) {
    return "**non-serializable** (" + e198 + ")";
  }
}
function f2237(p18571) {
  const v14232 = Object.getPrototypeOf(p18571);
  if (v14232) {
    return v14232.constructor.name;
  } else {
    return "null prototype";
  }
}
function f2238(p18572) {
  return ~-encodeURI(p18572).split(/%..|./).length;
}
function f2239(p18573) {
  return f2238(JSON.stringify(p18573));
}